export default function SeoContentSection() {
  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          <div className="lg:w-2/5">
            <span className="inline-block px-3 py-1 bg-background-200 text-foreground-600 rounded-md text-xs font-semibold tracking-wide border border-background-300/60 mb-6">
              SOBRE
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-6">
              Guia Definitivo{' '}
              <span className="font-light italic text-primary-500">CSSBuy 2026</span>
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-6 text-sm md:text-base">
              O CSSBuy Spreadsheet é uma das ferramentas mais utilizadas por compradores
              internacionais que desejam importar produtos da China com segurança e
              organização. Com ele, você pode comparar preços, lojas, qualidade e
              opções de envio antes de fazer qualquer compra.
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8 text-sm md:text-base">
              Este site foi criado para ser o guia definitivo sobre CSSBuy Spreadsheet,
              incluindo tabelas comparativas, estratégias para reduzir custos e evitar
              erros comuns na importação de produtos chineses.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-semibold text-sm border-b-2 border-primary-300 hover:border-primary-500 pb-1 transition-all"
            >
              Acesse kaspreadsheet.com
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div className="lg:w-3/5 w-full">
            <div className="flex items-center gap-6 mb-6">
              <div>
                <div className="text-4xl md:text-5xl font-heading font-bold text-primary-500">15+</div>
                <div className="text-xs text-foreground-500 mt-1">Categorias</div>
              </div>
              <div>
                <div className="text-4xl md:text-5xl font-heading font-bold text-accent-500">10K+</div>
                <div className="text-xs text-foreground-500 mt-1">Produtos</div>
              </div>
            </div>

            <div className="overflow-hidden rounded-xl border border-background-200/70">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-primary-500 text-background-50">
                    <th className="text-left px-5 py-3.5 font-semibold">Agente</th>
                    <th className="text-left px-5 py-3.5 font-semibold">Taxa</th>
                    <th className="text-left px-5 py-3.5 font-semibold">Frete</th>
                    <th className="text-left px-5 py-3.5 font-semibold">Segurança</th>
                    <th className="text-left px-5 py-3.5 font-semibold hidden md:table-cell">
                      Melhor Uso
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-background-50 border-b border-background-200/50">
                    <td className="px-5 py-3 font-semibold text-primary-600">CSSBuy</td>
                    <td className="px-5 py-3 text-foreground-700">Baixa</td>
                    <td className="px-5 py-3 text-foreground-700">Média</td>
                    <td className="px-5 py-3 text-secondary-600 font-medium">Alta</td>
                    <td className="px-5 py-3 text-foreground-600 hidden md:table-cell">
                      Iniciantes
                    </td>
                  </tr>
                  <tr className="bg-background-100/70 border-b border-background-200/50">
                    <td className="px-5 py-3 font-semibold text-foreground-800">Pandabuy</td>
                    <td className="px-5 py-3 text-foreground-700">Média</td>
                    <td className="px-5 py-3 text-foreground-700">Baixa</td>
                    <td className="px-5 py-3 text-secondary-600 font-medium">Alta</td>
                    <td className="px-5 py-3 text-foreground-600 hidden md:table-cell">
                      Streetwear
                    </td>
                  </tr>
                  <tr className="bg-background-50 border-b border-background-200/50">
                    <td className="px-5 py-3 font-semibold text-foreground-800">Superbuy</td>
                    <td className="px-5 py-3 text-foreground-700">Alta</td>
                    <td className="px-5 py-3 text-foreground-700">Alta</td>
                    <td className="px-5 py-3 text-secondary-600 font-medium">
                      Muito alta
                    </td>
                    <td className="px-5 py-3 text-foreground-600 hidden md:table-cell">
                      Premium
                    </td>
                  </tr>
                  <tr className="bg-background-100/70">
                    <td className="px-5 py-3 font-semibold text-foreground-800">Basetao</td>
                    <td className="px-5 py-3 text-foreground-700">Baixa</td>
                    <td className="px-5 py-3 text-foreground-700">Média</td>
                    <td className="px-5 py-3 text-foreground-700">Média</td>
                    <td className="px-5 py-3 text-foreground-600 hidden md:table-cell">
                      Avançado
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}